import React from 'react';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { Paper, Stack } from '@facet-wealth/design';
import CipStatusIcon from 'Views/Page/Content/Templates/WizardTemplates/CIPInformationVerificationTemplate/Content/CipStatusIcon';

export default function CIPStatusItem({
  resource,
  loading,
}) {
  const status = resource?.attr('status');
  const label = resource?.attr('label');

  return <>
    <Paper padding={400} width={'100%'}>
      <Stack alignItems={'center'} spacing={2} justifyContent="flex-start">
        <CipStatusIcon status={status} loading={loading} />
        <Stack direction={'column'} alignItems="flex-start" justifyContent="flex-start">
          <Text value={label} align={'left'} variant="h5" weight="bold" color={'textPrimary'} />
        </Stack>
      </Stack>
    </Paper>
  </>;
}
